import { isObject } from 'lodash';

const getForceMode = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('force-mode');
};

export const getForcePlatform = (): 'ios' | 'desktop' | 'android' | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const parameterValue = urlParams.get('force-platform');

  if (parameterValue === 'ios' || parameterValue === 'desktop' || parameterValue === 'android') {
    return parameterValue;
  }

  return null;
};

export const shouldHideHeader = () => {
  return new URLSearchParams(window.location.search).get('_no_header') !== null;
};

export const shouldHideBorder = () => {
  return new URLSearchParams(window.location.search).get('without-border') === 'true';
};

const isForceIframeMode = () => {
  return getForceMode() === 'iframe' || window.FORCE_IFRAME_MODE;
};

const isForcePollsSiteMode = () => {
  return getForceMode() === 'polls-site';
};

export const isForceWebviewMode = () => {
  return getForceMode() === 'webview';
};

export const inIframe = ({ ignoreForce }: { ignoreForce?: boolean } = {}) => {
  if (isForceIframeMode() && !ignoreForce) {
    return true;
  }

  if ((isForcePollsSiteMode() || isForceWebviewMode()) && !ignoreForce) {
    return false;
  }

  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export const isPollsSite = ({ ignoreForce }: { ignoreForce?: boolean } = {}) => {
  if (isForcePollsSiteMode() && !ignoreForce) {
    return true;
  }

  if ((isForceIframeMode() || isForceWebviewMode()) && !ignoreForce) {
    return false;
  }

  try {
    return document.body.id === 'PollsSite';
  } catch {
    return false;
  }
};

export const isWebview = ({ ignoreForce }: { ignoreForce?: boolean } = {}) => {
  if (window.FORCE_WEBVIEW_MODE) {
    return true;
  }

  if (isForceWebviewMode() && !ignoreForce) {
    return true;
  }

  return !isPollsSite({ ignoreForce }) && !inIframe({ ignoreForce });
};

export const resolveLinkUrl = (link: { webUrl: string; webviewUrl: string } | string | undefined) => {
  if (!isObject(link)) {
    return link;
  }

  if (isWebview()) {
    return link.webviewUrl || link.webUrl;
  }

  return link.webUrl;
};

export const resolveInlineLink = (link: string) => {
  const [webUrl, webviewUrl] = link.split(';');
  return resolveLinkUrl({ webUrl, webviewUrl: webviewUrl ?? '' });
};

export const isIOS = () => {
  const forcedPlatform = getForcePlatform();

  if (forcedPlatform === 'ios') {
    return true;
  } else if (forcedPlatform) {
    return false;
  }

  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (window.navigator) {
    return iosPlatforms.includes(window.navigator.platform);
  }

  return false;
};

export const isAndroid = () => {
  const forcedPlatform = getForcePlatform();

  if (forcedPlatform === 'android') {
    return true;
  } else if (forcedPlatform) {
    return false;
  }

  if (typeof window === 'undefined' || !window.navigator.userAgent) {
    return false;
  }

  return /Android/i.test(window.navigator.userAgent);
};
